const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const fmtMoney = (v?: number | string | null): string =>
  v != null ? formatter.format(Number(v)) : '-';

export const fmtPct = (v?: number | string | null): string =>
  v != null ? `${(Number(v) * 100).toFixed(1)}%` : '-';
